import script from "./FindId.vue?vue&type=script&setup=true&lang=js"
export * from "./FindId.vue?vue&type=script&setup=true&lang=js"

import "./FindId.vue?vue&type=style&index=0&id=0d492b25&scope=true&lang=css"

const __exports__ = script;

export default __exports__